var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notif-error"},[_c('div',{staticClass:"notif-close",on:{"click":_vm.closeModal}}),_c('p',{staticClass:"notif-text",domProps:{"innerHTML":_vm._s(_vm.errorTxt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }